// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"CustomButton_secondaryButton__O2iqF","child":"CustomButton_child__333RY","icon":"CustomButton_icon__3OgZC"};